import { useState } from 'react';
import axios from 'axios';
import { apiPath } from '../services/apiBase';

// Hook: useImageUpload
export function useImageUpload() {
  const [uploading, setUploading] = useState(false);
  const [progress,  setProgress]  = useState(0);

  const uploadImage = async (file) => {
    const formData = new FormData();
    formData.append('image', file);
    setUploading(true);
    try {
      const token = localStorage.getItem('yamass_token');
      const res = await axios.post(apiPath('/upload'), formData, {
        headers: {
          'Content-Type':  'multipart/form-data',
          'Authorization': `Bearer ${token}`,
        },
        onUploadProgress: (e) => {
          setProgress(Math.round((e.loaded * 100) / e.total));
        },
      });
      return res.data.url;
    } finally {
      setUploading(false);
      setProgress(0);
    }
  };

  const uploadMultiple = async (files) => {
    const formData = new FormData();
    files.forEach(f => formData.append('images', f));
    setUploading(true);
    try {
      const token = localStorage.getItem('yamass_token');
      const res = await axios.post(apiPath('/upload/multiple'), formData, {
        headers: {
          'Content-Type':  'multipart/form-data',
          'Authorization': `Bearer ${token}`,
        },
      });
      return res.data.images.map(i => i.url);
    } finally {
      setUploading(false);
    }
  };

  return { uploadImage, uploadMultiple, uploading, progress };
}
